import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../../../services/common.service";

@Component({
	selector: 'page-info-cancel-index',
	templateUrl: './index.component.html',
})
export class PageInfoCancelIndexComponent implements OnInit {

    public $: any;

	constructor(
        public commonService: CommonService,
    ) {
        this.$ = this.commonService.getJQuery();
	}

	async ngOnInit() {

        /* SET PAGE TITLE */
        this.commonService.setTitle(`予約の変更・取消について | バスブックマーク`);

        this.commonService.showPageLoader("しばらくお待ちください。");

		/* EXECUTE INLINE JAVASCRIPT */
        this.inlineJS();

        this.commonService.hidePageLoader();
    }

    inlineJS() {
        let self = this;

        self.$(document).ready(function() {

            self.$('.faq-body-box').click(function() {
                self.$(this).toggleClass("is--active");
                self.$(this).children(".faq-body-box__a").slideToggle();
            });
            self.$('.acc-title').click(function() {
                self.$(this).toggleClass("is--active");
                self.$(this).next(".faq-body").slideToggle();
            });

        });
    }

}
